import { createSlice } from "@reduxjs/toolkit";
import {
  fetchExpertCountries,
  fetchFamousExperts,
  fetchNewComerExperts,
  fetchTotalExpertCount,
  fetchHomePageLessonsByTags,
  fetchHomePageTeachers,
  // getLessonsTags,
  fetchHomePagePopularLessons,
  fetchExpertCountriesFlat,
} from "redux/actions";
import { IExpertRegion, INewComerExpert, ICountry } from "../../types/redux/home";
import { IExpert } from "../../types/components/expert";
import { LessonModel, TeacherModel } from "redux/models/home";

export interface IHome {
  expertCount: number;
  expertRegions: IExpertRegion[];
  expertCountries: ICountry[];
  newComerExperts: INewComerExpert[];
  famousExperts: IExpert[];
  teachers: TeacherModel[];
  lessons: LessonModel[];
  popularLessons: LessonModel[];
  loading: boolean;
}

const initial: IHome = {
  expertCount: 0,
  expertRegions: [],
  expertCountries: [],
  newComerExperts: [],
  famousExperts: [],
  teachers: [],
  lessons: [],
  popularLessons: [],
  loading: false,
};

export const homeSlice = createSlice({
  name: "home",
  initialState: initial,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchExpertCountries.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchExpertCountries.fulfilled, (state, action) => {
      state.loading = false;
      state.expertRegions = action.payload;
    });
    builder.addCase(fetchExpertCountries.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(fetchExpertCountriesFlat.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchExpertCountriesFlat.fulfilled, (state, action) => {
      state.loading = false;
      state.expertCountries = action.payload;
    });
    builder.addCase(fetchExpertCountriesFlat.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(fetchNewComerExperts.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchNewComerExperts.fulfilled, (state, action) => {
      state.loading = false;
      state.newComerExperts = action.payload;
    });
    builder.addCase(fetchNewComerExperts.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(fetchFamousExperts.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchFamousExperts.fulfilled, (state, action) => {
      state.loading = false;
      state.famousExperts = action.payload;
    });
    builder.addCase(fetchFamousExperts.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(fetchTotalExpertCount.fulfilled, (state, action) => {
      state.loading = false;
      state.expertCount = action.payload;
    });

    //home page lessons by tags
    builder.addCase(fetchHomePageLessonsByTags.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchHomePageLessonsByTags.fulfilled, (state, action) => {
      state.loading = false;
      state.lessons = action.payload;
    });
    builder.addCase(fetchHomePageLessonsByTags.rejected, (state) => {
      state.loading = false;
      state.lessons = [];
    });
    //home page Popular lessons
    builder.addCase(fetchHomePagePopularLessons.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchHomePagePopularLessons.fulfilled, (state, action) => {
      state.loading = false;
      state.popularLessons = action.payload;
    });
    builder.addCase(fetchHomePagePopularLessons.rejected, (state) => {
      state.loading = false;
      state.lessons = [];
    });

    //home page teachers
    builder.addCase(fetchHomePageTeachers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchHomePageTeachers.fulfilled, (state, action) => {
      state.loading = false;
      state.teachers = action.payload;
    });
    builder.addCase(fetchHomePageTeachers.rejected, (state) => {
      state.loading = false;
      state.teachers = [];
    });

    // //lessons tags
    // builder.addCase(getLessonsTags.pending, (state) => {
    //   state.loading = true;
    // });
    // builder.addCase(getLessonsTags.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.lessonTags = action.payload;
    // });
    // builder.addCase(getLessonsTags.rejected, (state) => {
    //   state.loading = false;
    //   state.lessonTags = [];
    // });
  },
});

export const {} = homeSlice.actions;

export default homeSlice.reducer;
